import { IProps as FeatureGridItem } from 'marketing-site/src/library/elements/FeatureGridItem'
import { IFeatureGridItem as IContentfulFeatureGridItem } from 'marketing-site/@types/generated/contentful'

export function transformGridItem(
  data: IContentfulFeatureGridItem,
  gridAlignment: boolean,
): FeatureGridItem {
  return {
    name: data.fields.name,
    description: data.fields.description,
    centerAlign: gridAlignment,
  }
}
